/* ROCKINTOR — Force the Shopify account/login sheet to use its dark palette. */
(function () {
  'use strict';

  var STYLE_ID = 'rk-login-modal-black-shadow-override';
  var observedRoots = new WeakSet();

  var overrideCss = `
    :host {
      color-scheme: dark;
      --shopify-account-color-background: #000 !important;
      --shopify-account-color-background-subdued: #111 !important;
      --shopify-account-color-card-background: #000 !important;
      --shopify-account-color-card-text: #fff !important;
      --shopify-account-color-control-background: #111 !important;
      --shopify-account-color-control-text: #fff !important;
      --shopify-account-color-text: #fff !important;
      --shopify-account-color-text-subdued: #b8b8b8 !important;
      --shopify-account-color-border: #3a3a3a !important;
      --shopify-account-color-shadow: rgba(0, 0, 0, 0.75) !important;
      --shopify-account-color-accent: #fff !important;
      --shopify-account-color-accent-hover: #e6e6e6 !important;
      --shopify-account-color-accent-text: #000 !important;
    }

    .account,
    .account__header-region,
    .account__header,
    .account__header-content,
    .account__content,
    .account__login-slot,
    .account__menu-region,
    .account__menu-items,
    .account__menu-items nav,
    .login-form__root,
    .login-form__email-form,
    .login-form__email-input-wrapper {
      background-color: #000 !important;
      background-image: none !important;
      color: #fff !important;
    }

    .account__heading,
    .account__close,
    .account__close svg,
    .login-form__divider-text,
    .login-form__marketing-consent,
    .login-form__marketing-consent-label,
    .login-form__marketing-consent-icon {
      color: #fff !important;
    }

    /*
     * Shopify renders both a placeholder and a floating label in this field.
     * Keep the real label accessible, but visually hide it to avoid duplicate text.
     */
    .login-form__email-label {
      position: absolute !important;
      width: 1px !important;
      height: 1px !important;
      padding: 0 !important;
      margin: -1px !important;
      overflow: hidden !important;
      clip: rect(0, 0, 0, 0) !important;
      white-space: nowrap !important;
      border: 0 !important;
    }

    .account__close.button,
    .account__close.button:hover,
    .account__close.button:focus-visible {
      background: #111 !important;
      border-color: #272727 !important;
      box-shadow: none !important;
      color: #fff !important;
    }

    .account__menu-items .button.outline,
    .account__menu-items .button.outline:hover,
    .account__menu-items .button.outline:focus-visible {
      background: #000 !important;
      border-color: #3a3a3a !important;
      color: #fff !important;
    }

    .login-form__divider-line {
      background-color: #3a3a3a !important;
      border-color: #3a3a3a !important;
    }

    .login-form__email-input {
      background: #111 !important;
      border-color: #3a3a3a !important;
      color: #fff !important;
    }

    .login-form__email-input::placeholder {
      color: #aaa !important;
      opacity: 1 !important;
    }

    .login-form__email-submit,
    .login-form__email-submit svg {
      color: #fff !important;
    }

    .login-form__marketing-consent-visual {
      background-color: #111 !important;
      border-color: #555 !important;
      color: #fff !important;
    }
  `;

  function isRelevantShadowRoot(root) {
    if (!root || !root.host) return false;

    var tagName = root.host.tagName;
    return tagName === 'SHOPIFY-ACCOUNT' ||
      tagName === 'SHOPIFY-LOGIN-FORM-LOADER' ||
      tagName === 'SHOPIFY-LOGIN-FORM' ||
      Boolean(root.querySelector('.account, .login-form__root'));
  }

  function injectOverride(root) {
    if (!isRelevantShadowRoot(root) || root.getElementById(STYLE_ID)) return;

    var style = document.createElement('style');
    style.id = STYLE_ID;
    style.textContent = overrideCss;
    root.appendChild(style);
  }

  function scan(root) {
    if (!root) return;

    if (root instanceof ShadowRoot) {
      injectOverride(root);

      if (!observedRoots.has(root)) {
        observer.observe(root, { childList: true, subtree: true });
        observedRoots.add(root);
      }
    }

    if (!root.querySelectorAll) return;

    root.querySelectorAll('*').forEach(function (element) {
      if (element.shadowRoot) scan(element.shadowRoot);
    });
  }

  var observer = new MutationObserver(function () {
    scan(document);
  });

  function refreshOverrides() {
    scan(document);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', refreshOverrides, { once: true });
  } else {
    refreshOverrides();
  }

  observer.observe(document.documentElement, { childList: true, subtree: true });

  /* Shopify may create the nested login form only after the account icon is clicked. */
  document.addEventListener('click', function () {
    requestAnimationFrame(refreshOverrides);
    window.setTimeout(refreshOverrides, 100);
    window.setTimeout(refreshOverrides, 500);
  }, true);
}());